<script setup lang="ts">
import { computed } from "vue"
import ToggleSwitch from "@/components/ToggleSwitch.vue"
import FormRow from "@/components/Common/FormRow.vue"

const emits = defineEmits(['update:modelValue'])
const props = defineProps<{
    title: string
    modelValue: boolean
}>()

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", value);
  },
})
</script>
<template>
  <FormRow
    :title="props.title"
  >
    <ToggleSwitch
      v-model="modelValue"
      className="mt-3"
    />
  </FormRow>
</template>